"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./lib/ActorHttpProxy"));
__export(require("./lib/ProxyHandlerStatic"));
//# sourceMappingURL=index.js.map